export default {
  pageTitle: '任务列表',
  pageSub: '新建任务置顶显示 · 全流程 / 仅拣选 / 仅复核三类任务并存',
  deviceManage: '设备管理',
  newDispatch: '+ 新建派单',
  filterFlow: '流程',
  filterFlowAll: '全部流程',
  filterFlowAllType: '全流程',
  filterFlowPickOnly: '仅拣选',
  filterFlowChkOnly: '仅复核',
  filterPost: '岗位',
  filterPostAll: '全部岗位',
  filterPostPick: '当前处于拣选',
  filterPostCheck: '当前处于复核',
  filterStatus: '状态',
  filterStatusAll: '全部',
  filterExc: '异常类型',
  filterExcAll: '全部',
  filterExcNone: '无异常',
  filterKw: '任务号 / 订单号',
  filterKwPlaceholder: '输入关键词',
  totalCount: '共 {n} 条',
  empty: '没有符合条件的任务',
  colTaskNo: '任务号',
  colFlow: '流程',
  colStep: '当前步骤',
  colOrderNo: '订单号',
  colPickSt: '拣选工位',
  colChkSt: '复核工位',
  colQty: '件数',
  colBox: '播种框',
  colBay: '架位',
  colPosition: '停靠位',
  colDevice: '执行设备',
  colPickCheck: '拣选 / 复核',
  colExcType: '异常类型',
  colStatus: '状态',
  colProgress: '进度',
  colCreated: '创建时间',
  colAction: '操作',
  stepPick: '拣选',
  stepCheck: '复核',
  statusPending: '待执行',
  statusRunning: '执行中',
  statusHandle: '待处置',
  statusDone: '已完成',
  statusError: '异常',
  stepNameNone: '待开始',
  stepNamePick: '拣选执行',
  stepNameCheck: '复核执行',
  stepNameDone: '已完成',
  excOrder: '订单异常',
  excScan: '扫码失败',
  excQty: '数量不符',
  excMismatch: '商品不符',
  excTimeout: '超时',
  excPendingSuffix: ' · 待处置',
  actionDetail: '详情',
  actionHandle: '处置',
  posLeft: '左位 L',
  posRight: '右位 R',
}
